import { InputType } from '../Enums/InputType';
import { CustomValidation } from './CustomValidation';
import { ControlLayout } from '../Enums/ControlLayout';
import { RangeNumber } from './RangeNumber';
import { ForceDirection } from '../Enums/ForceDirection';
import { Dictionary } from 'lodash';
import { Attribute } from './Attribute';
import { StartView } from '../Enums/StartView';
import { PickerType } from '../Enums/PickerType';
import { SelectMode } from '../Enums/SelectMode';

export class DatePickerOptions {

   /**
 * Represent Name Of Form Control
 */
Name:string
/**
*   Represent classes to DatePicer that allow us to select the DatePicker by jquery or javascript 
*/

ExtraClasses:string

/**  Represent value of the label*/
LabelValue:string

 /**  Represent Key of the label*/
 LabelKey:string
/**  Represent value of the labelDescription show under DatePicker*/
LabelDescription:string
/** Represent value of the Placeholder of DatePicker */
Placeholder:string
/**To set  value  to DatePicker */
Value:Date
/**To set  StartDate  to DatePicker */
StartDate: Date
/**To set  EndDate  to DatePicker */
EndDate: Date;
/**
* Display "*" beside the label 
* if ForceAsterisk=true and IsRequired=True his display "*" ,
* if if ForceAsterisk=false and IsRequired=false this remove "*",
*if ForceAsterisk=false and IsRequired=True this display "*" , 
*/ 
ShowAsterisk: boolean
/** Ability to set  DatePicker required */
IsRequired: boolean
/** Ability to display or hide the label of DatePicker */
HideLabel:  boolean
/** Sets an attribute disable="disabled"  */
IsDisabled: boolean
/** add button to for coping to clipboard */
EnableCopyToClipboard: boolean
/**  to set type of view  if DatePicker is Vertical or Horizontal */
ViewType:ControlLayout=ControlLayout.Vertical
/** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
*/
CustomValidation: CustomValidation[]=[]

IsGMT:boolean 
/**To set  First Day Of Week  to DatePicker */
FirstDayOfWeek:Number=1
/**To set Hour12Timer to DatePicker  is 12 Hour or 24 Hour*/
Hour12Timer:boolean
/**To set PickerType to DatePicker  is Calendar or Timer Or Both */
PickerType:PickerType=PickerType.Calendar
/**To set StartView to DatePicker  is Year or Month Or Multi-Year */
StartView:StartView=StartView.Month
/**To set SelectMode to DatePicker  is Single or Range */
SelectMode:SelectMode=SelectMode.Single
/**To set AttributeList to DatePicker */
AttributeList:Attribute[]
ForceDirection: ForceDirection=ForceDirection.English

}
